import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';
import { SupportAppConfigComponent } from './components/appconfig/app-config.component'

const routes = [
  {
    path: 'support/appconfig',
    component: SupportAppConfigComponent,
    canActivate:[CanActivateViaAuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SupportRoutingModule { }
